export const CREATING_NOTE = "CREATING_NOTE"
export const DELETING_NOTE = "DELETING_NOTE"
export const EDIT_NOTE = "EDIT_NOTE"
export const FETCH_NOTES = "FETCH_NOTES"

